import { jsx } from 'react/jsx-runtime';

const Content = ({ width, height, className, }) => (jsx("svg", { className: className, height: height, viewBox: "0 0 7 14", width: width, xmlns: "http://www.w3.org/2000/svg", children: jsx("g", { id: "Group 26086295", children: jsx("path", { d: "M6.88208 5.24289H3.62438L6.47278 0.5H2.89242L0.5 7.20696H3.47237L1.66231 13.2642L6.88208 5.24289Z" // @suppress longLineCheck
            , fill: "currentColor", id: "Path 33733" }) }) }));

export { Content as C };
//# sourceMappingURL=component-CFeKeHVY.js.map
